import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosServices from '../../utils/axiosSupplier';

// Tedarikçi bilgilerini getir
export const getSupplier = createAsyncThunk(
    'supplierApp/getSupplier',
    async (idSupplier, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-supplier?idSupplier=${idSupplier}`
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Tedarikçi bilgileri alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Tedarikçi bilgileri yüklenirken bir hata oluştu');
        }
    }
);

// Tedarikçi bakiye bilgilerini getir
export const getSupplierBalance = createAsyncThunk(
    'supplierApp/getSupplierBalance',
    async (idSupplier, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/get-balance?idSupplier=${idSupplier}`
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Bakiye bilgileri alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Bakiye bilgileri yüklenirken bir hata oluştu');
        }
    }
);

// Tedarikçi hizmetlerini getir
export const fetchSupplierServices = createAsyncThunk(
    'supplierApp/fetchSupplierServices',
    async ({ idSupplier, rowCount }, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-service?idSupplier=${idSupplier}&rowCount=${rowCount}`
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Hizmet listesi alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'Hizmet listesi yüklenirken bir hata oluştu');
        }
    }
);

// İhbar detayını getir
export const getNotificationDetail = createAsyncThunk(
    'supplierApp/getNotificationDetail',
    async (idNotification, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Notification/get-notification?idNotification=${idNotification}`
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'İhbar detayı alınamadı');
        } catch (error) {
            return rejectWithValue(error.message || 'İhbar detayı yüklenirken bir hata oluştu');
        }
    }
);

// Araç yükleme/indirme bilgilerini gönder
export const addNotificationVehicle = createAsyncThunk(
    'supplierApp/addNotificationVehicle',
    async (addNotificationVehicles, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/add-notification-vehicle`,
                { addNotificationVehicles }
            );

            if (response.data?.statu === 200) {
                return response.data.data;
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Dosya bilgileri gönderilemedi');
        } catch (error) {
            return rejectWithValue(error.message || 'İşlem sırasında bir hata oluştu');
        }
    }
);

// Ödeme talebi gönder
export const setWithdrawPayment = createAsyncThunk(
    'supplierApp/setWithdrawPayment',
    async (paymentData, { rejectWithValue }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/SupAccount/set-withdraw-payment`,
                paymentData
            );

            if (response.data?.statu === 200) {
                return response.data;
            }

            // Status 500 ve exceptions varsa mesajı çıkart
            if (response.data?.statu === 500 && response.data?.exceptions && response.data.exceptions.length > 0) {
                return rejectWithValue(response.data.exceptions[0].Message || 'İşlem sırasında bir hata oluştu');
            }

            // Validasyon hatalarını kontrol et
            if (response.data?.statu === 800) {
                return rejectWithValue({
                    statu: 800,
                    exceptions: response.data.exceptions
                });
            }

            return rejectWithValue(response.data?.exceptions?.[0]?.Message || response.data?.message || 'Hata oluştu');
        } catch (error) {
            // Axios hata yanıtını kontrol et
            if (error.response?.data?.statu === 500 && error.response?.data?.exceptions && error.response.data.exceptions.length > 0) {
                return rejectWithValue(error.response.data.exceptions[0].Message);
            }
            
            if (error.response?.data?.exceptions && error.response.data.exceptions.length > 0) {
                // API yanıtındaki ilk exception'ın Message alanını döndür
                return rejectWithValue(error.response.data.exceptions[0].Message);
            } else if (error.response?.data?.message) {
                // Alternatif message alanı
                return rejectWithValue(error.response.data.message);
            } else if (error.response?.data) {
                // Genel hata yanıtı
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message || 'İşlem sırasında bir hata oluştu');
        }
    }
);

const initialState = {
    supplierDetail: {
        loading: false,
        error: null,
        data: null
    },
    balance: {
        loading: false,
        error: null,
        data: null
    },
    services: {
        loading: false,
        error: null,
        data: []
    },
    notificationDetail: {
        loading: false,
        error: null,
        data: null
    },
    notificationVehicle: {
        loading: false,
        error: null,
        data: null
    },
    withdrawPayment: {
        loading: false,
        error: null,
        data: null
    }
};

const supplierAppSlice = createSlice({
    name: 'supplierApp',
    initialState,
    reducers: {
        clearSupplierData: (state) => {
            state.supplierDetail.data = null;
            state.balance.data = null;
            state.services.data = [];
        },
        clearNotificationDetail: (state) => {
            state.notificationDetail.data = null;
        },
        clearNotificationVehicle: (state) => {
            state.notificationVehicle = {
                loading: false,
                error: null,
                data: null
            };
        }
    },
    extraReducers: (builder) => {
        builder
            // Tedarikçi bilgileri
            .addCase(getSupplier.pending, (state) => {
                state.supplierDetail.loading = true;
                state.supplierDetail.error = null;
            })
            .addCase(getSupplier.fulfilled, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.data = action.payload;
                state.supplierDetail.error = null;
            })
            .addCase(getSupplier.rejected, (state, action) => {
                state.supplierDetail.loading = false;
                state.supplierDetail.error = action.payload;
            })

            // Bakiye bilgileri
            .addCase(getSupplierBalance.pending, (state) => {
                state.balance.loading = true;
                state.balance.error = null;
            })
            .addCase(getSupplierBalance.fulfilled, (state, action) => {
                state.balance.loading = false;
                state.balance.data = action.payload;
                state.balance.error = null;
            })
            .addCase(getSupplierBalance.rejected, (state, action) => {
                state.balance.loading = false;
                state.balance.error = action.payload;
            })

            // Hizmet listesi
            .addCase(fetchSupplierServices.pending, (state) => {
                state.services.loading = true;
                state.services.error = null;
            })
            .addCase(fetchSupplierServices.fulfilled, (state, action) => {
                state.services.loading = false;
                state.services.data = action.payload;
                state.services.error = null;
            })
            .addCase(fetchSupplierServices.rejected, (state, action) => {
                state.services.loading = false;
                state.services.error = action.payload;
            })

            // İhbar detayı
            .addCase(getNotificationDetail.pending, (state) => {
                state.notificationDetail.loading = true;
                state.notificationDetail.error = null;
            })
            .addCase(getNotificationDetail.fulfilled, (state, action) => {
                state.notificationDetail.loading = false;
                state.notificationDetail.data = action.payload;
                state.notificationDetail.error = null;
            })
            .addCase(getNotificationDetail.rejected, (state, action) => {
                state.notificationDetail.loading = false;
                state.notificationDetail.error = action.payload;
            })

            // Araç yükleme/indirme bilgileri
            .addCase(addNotificationVehicle.pending, (state) => {
                state.notificationVehicle.loading = true;
                state.notificationVehicle.error = null;
            })
            .addCase(addNotificationVehicle.fulfilled, (state, action) => {
                state.notificationVehicle.loading = false;
                state.notificationVehicle.data = action.payload;
                state.notificationVehicle.error = null;
            })
            .addCase(addNotificationVehicle.rejected, (state, action) => {
                state.notificationVehicle.loading = false;
                state.notificationVehicle.error = action.payload;
            })

            // Ödeme talebi
            .addCase(setWithdrawPayment.pending, (state) => {
                state.withdrawPayment.loading = true;
                state.withdrawPayment.error = null;
            })
            .addCase(setWithdrawPayment.fulfilled, (state, action) => {
                state.withdrawPayment.loading = false;
                state.withdrawPayment.data = action.payload;
                state.withdrawPayment.error = null;
            })
            .addCase(setWithdrawPayment.rejected, (state, action) => {
                state.withdrawPayment.loading = false;
                state.withdrawPayment.error = action.payload;
            });
    }
});

export const { clearSupplierData, clearNotificationDetail, clearNotificationVehicle } = supplierAppSlice.actions;
export default supplierAppSlice.reducer;
